import { Fill, FillType, LayerType } from 'modules/shares/types'
import { capitalize } from 'utils'
import rgbTo, { ColorFormat } from '../Attribute/components/Color/utils'
import copyGradient from '../GradientAttribute/copy'
import { roundWithLocale } from 'utils/math'

const fillCopy = (
  {
    isEnabled,
    type,
    color,
    gradient,
    patternFillType,
    patternTileScale,
    appearance,
  }: Fill,
  index: number,
  colorFormat?: ColorFormat,
  layerType?: LayerType
) => {
  if (!isEnabled) {
    return null
  }

  const blendMode = appearance?.blendMode
  const opacity = appearance?.opacity !== undefined ? appearance?.opacity : 1

  let copyValue = null

  switch (type) {
    case FillType.Color: {
      if (color) {
        copyValue = `Color: ${rgbTo(colorFormat, color)}`
      }
      break
    }
    case FillType.Gradient: {
      if (gradient) {
        copyValue = copyGradient(gradient, opacity, colorFormat)
      }
      break
    }
    case FillType.Pattern: {
      if (patternFillType) {
        copyValue = `Type: Image\nDisplay: ${capitalize(patternFillType)}`
      }
      if (patternTileScale && typeof patternTileScale === 'number') {
        copyValue += `\nSize: ${roundWithLocale(patternTileScale * 100, 2)}%`
      }
      break
    }
    default:
      return null
  }

  copyValue = `${
    layerType === 'group' ? 'Tint' : 'Fill'
  } ${++index}\n${copyValue}`

  if (blendMode.toUpperCase() !== 'NORMAL') {
    copyValue += `\nBlend mode: ${capitalize(blendMode)}`
  }

  if (opacity < 1) {
    copyValue += `\nOpacity: ${(appearance.opacity * 100).toFixed()}%`
  }

  return copyValue
}

const copy = (
  fills: Fill[],
  colorFormat?: ColorFormat,
  layerType?: LayerType
) => {
  return fills
    .map((fill, index) => fillCopy(fill, index, colorFormat, layerType))
    .filter(f => f !== null)
    .join('\n\n')
}

export default copy
